import { createModel } from "~~/package/utils/ModelUtil";
import Model from "~~/package/mapper/Model";
import {
  ProSkillManagerActionUserInfoModel
} from "~~/package/mapper/proSkillManager/model/actions/ProSkillManagerActionUserInfoModel";
import {
  ProSkillManagerSubmissionAssessmentResultModel
} from "~~/package/mapper/proSkillManager/model/submission/ProSkillManagerSubmissionAssessmentResultModel";

export class ProSkillManagerSubmissionModel extends Model {
  constructor(
    public order: number = 0,
    public title: string | null = null,
    public trackId: number = 0,
    public trackTitle: string | null = null,
    public trackLevelTitle: string | null = null,
    public userInfo: ProSkillManagerActionUserInfoModel = new ProSkillManagerActionUserInfoModel(),
    public assessmentResults: ProSkillManagerSubmissionAssessmentResultModel[] = []
  ) {
    super();
  }

  public static create(model: Partial<ProSkillManagerSubmissionModel>): ProSkillManagerSubmissionModel {
    return createModel<ProSkillManagerSubmissionModel>(ProSkillManagerSubmissionModel, {
      ...model
    });
  }
}
